module.exports = __webpack_public_path__ + "img/ic_initiative@2x.001e6c49.png";